var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.019,
    height: 22.019,
    viewBox: "0 0 22.019 22.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(-0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3292",
    "data-name": "Trazado 3292",
    d: "M159.16,0a6.15,6.15,0,1,0,6.15,6.15A6.157,6.157,0,0,0,159.16,0Zm.646,8.945V9.08a.645.645,0,1,1-1.29,0V9.018a2.335,2.335,0,0,1-.912-.388.645.645,0,1,1,.707-1.08,1.144,1.144,0,0,0,.846.219.612.612,0,0,0,.613-.52.431.431,0,0,0-.323-.515,5.385,5.385,0,0,1-1.474-.712,1.616,1.616,0,0,1,.544-2.7V3.225a.645.645,0,1,1,1.29,0v.053a2.1,2.1,0,0,1,.726.392.645.645,0,0,1-.872.95.779.779,0,0,0-.687-.1.359.359,0,0,0-.229.284.252.252,0,0,0,.025.2,4.6,4.6,0,0,0,1.108.511,1.812,1.812,0,0,1-.07,3.427Z",
    transform: "translate(-146.42)",
    fill: "#0056a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3293",
    "data-name": "Trazado 3293",
    d: "M18.656,274.9l-6.264,1.845a4.118,4.118,0,0,1,.3,1.56v.227a2.215,2.215,0,0,1-3.122,2.019l-3.283-1.478A.645.645,0,0,1,6.82,277.9l3.283,1.478a.923.923,0,0,0,1.3-.842v-.227a2.792,2.792,0,0,0-1.664-2.534L6.9,274.494a4.177,4.177,0,0,0-3.465.015L.388,275.9a.645.645,0,0,0-.378.587v6.864a.646.646,0,0,0,.875.619l4.3-1.636,5.109,1.788a4.157,4.157,0,0,0,3.5-.347l6.95-4.093a2.628,2.628,0,0,0-2.085-4.78Z",
    transform: "translate(0 -262.337)",
    fill: "#0056a3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.c669dec5305d571c45e6ba7b57d23063.svg";
export { ForwardRef as ReactComponent };